import { GET_ACTIVE_FACILITIES_FAILURE, GET_ACTIVE_FACILITIES_SUCCESS, GET_CERTIFICATE_OVERVIEW_FAILURE, GET_CERTIFICATE_OVERVIEW_SUCCESS, GET_CLEANING_AUDIT_STATUS_FAILURE, GET_CLEANING_AUDIT_STATUS_SUCCESS, GET_COMMUNICATION_STATUS_FAILURE, GET_COMMUNICATION_STATUS_SUCCESS, GET_EDUCATION_TRAINING_OVERVIEW_FAILURE, GET_EDUCATION_TRAINING_OVERVIEW_SUCCESS, GET_EQUIPMENT_OVERVIEW_FAILURE, GET_EQUIPMENT_OVERVIEW_SUCCESS, GET_FACILITY_STATUS_FAILURE, GET_FACILITY_STATUS_SUCCESS, GET_LAUNDRY_AUDIT_STATUS_FAILURE, GET_LAUNDRY_AUDIT_STATUS_SUCCESS, GET_PERIODICAL_STATUS_FAILURE, GET_PERIODICAL_STATUS_SUCCESS, GET_STAFF_DETAILS_FAILURE, GET_STAFF_DETAILS_SUCCESS } from "redux/constants/MyM";


const initStat = { activeFacilitiesData: [] ,facilityStatusData: [], periodicalStatusData: [], communicationStatusData: [], cleaningAuditStatusData: [], laundryAuditStatusData: [], staffDetails: [], equipmentOverviewData: [], certificateOverviewData: [], educationOverviewData: [], error: false, errorData: "", isLoadingCommon: true, isLoading: true };

export default (state = initStat, action) => {
    switch (action.type) {
        case GET_FACILITY_STATUS_SUCCESS:
            return {
                ...state,
                facilityStatusData: action.payload,
                isLoadingCommon: false,
            };
        case GET_FACILITY_STATUS_FAILURE:
            return { ...state, isLoadingCommon: false, errorData: action.payload, error: true };

        case GET_ACTIVE_FACILITIES_SUCCESS:
            return {
                ...state,
                activeFacilitiesData: action.payload,
                isLoadingCommon: false,
            };
        case GET_ACTIVE_FACILITIES_FAILURE:
            return { ...state, isLoadingCommon: false, errorData: action.payload, error: true };


        case GET_PERIODICAL_STATUS_SUCCESS:
            return {
                ...state,
                periodicalStatusData: action.payload,
                isLoading: false,
            };
        case GET_PERIODICAL_STATUS_FAILURE:
            return { ...state, isLoading: false, errorData: action.payload, error: true };

        case GET_CLEANING_AUDIT_STATUS_SUCCESS:
            return {
                ...state,
                cleaningAuditStatusData: action.payload,
                isLoading: false,
            };
        case GET_CLEANING_AUDIT_STATUS_FAILURE:
            return { ...state, isLoading: false, errorData: action.payload, error: true };

        case GET_LAUNDRY_AUDIT_STATUS_SUCCESS:
            return {
                ...state,
                laundryAuditStatusData: action.payload,
                isLoading: false,
            };
        case GET_LAUNDRY_AUDIT_STATUS_FAILURE:
            return { ...state, isLoading: false, errorData: action.payload, error: true };

        case GET_EQUIPMENT_OVERVIEW_SUCCESS:
            return {
                ...state,
                equipmentOverviewData: action.payload,
                isLoadingCommon: false,
            };
        case GET_EQUIPMENT_OVERVIEW_FAILURE:
            return { ...state, isLoadingCommon: false, errorData: action.payload, error: true };

        case GET_CERTIFICATE_OVERVIEW_SUCCESS:
            return {
                ...state,
                certificateOverviewData: action.payload,
                isLoadingCommon: false,
            };
        case GET_CERTIFICATE_OVERVIEW_FAILURE:
            return { ...state, isLoadingCommon: false, errorData: action.payload, error: true };

        case GET_EDUCATION_TRAINING_OVERVIEW_SUCCESS:
            return {
                ...state,
                educationOverviewData: action.payload,
                isLoading: false,
            };
        case GET_EDUCATION_TRAINING_OVERVIEW_FAILURE:
            return { ...state, isLoading: false, errorData: action.payload, error: true };

        case GET_COMMUNICATION_STATUS_SUCCESS:
            return {
                ...state,
                communicationStatusData: action.payload,
                isLoading: false,
            };
        case GET_COMMUNICATION_STATUS_FAILURE:
            return { ...state, isLoading: false, errorData: action.payload, error: true };

        case GET_STAFF_DETAILS_SUCCESS:
            return {
                ...state,
                staffDetails: action.payload,
                isLoadingCommon: false,
            };
        case GET_STAFF_DETAILS_FAILURE:
            return { ...state, isLoadingCommon: false, errorData: action.payload, error: true };

        default:
            return { ...state };
    }
};
